import { Button, Dialog } from '@mui/material';
import React from 'react';
import { FunctionComponent, ReactElement, useState } from 'react';

export const DialogButton: FunctionComponent<{
  label: string;
  children: (closeDialog: () => void) => ReactElement;
  button?: JSX.Element;
}> = ({ label, children, button = <Button>{label}</Button> }) => {
  const [open, setOpen] = useState(false);

  const buttonWithEvent = React.cloneElement(button, {
    onClick: () => setOpen(true),
  });

  return (
    <>
      {buttonWithEvent}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
        {children(() => setOpen(false))}
      </Dialog>
    </>
  );
};
